/* -------------------------- */
/* Theme custom JavaScript.   */
/* -------------------------- */

!function($) {

    // Document ready
    $(function() {
      
      // Only call these functions on product page
      if ( $('html').hasClass('template-product') ){

        // Re-arrange product info to tabs on product page
        productTabs();

      }

      // MyHalti Product Search
      myHaltiProductSearch(); 

    });

  // Functions
  function productTabs() {
    
      // Create variables for tabs content
      $features = $('.tabs-content #tab1').children();
      $materials = $('.tabs-content #tab2').children();
      $size = $('.tabs-content #tab3').children();
      
      // Some products don't have instructions
      if ( $('.tabs-content #tab4').length > 0 ) {
          $instructions = $('.tabs-content #tab4').children();
          $('.tab-instructions .tab-content__inner').append($instructions);
      } else {
          $('.tab-instructions').remove();
      }
      
      // Add content to new tabs
      $('.tab-features .tab-content__inner').append($features);
      $('.tab-materials .tab-content__inner').append($materials);
      $('.tab-size .tab-content__inner').append($size);
      
      // Description as tab is optionary 
      if ( $('.tab-description').length > 0 ) {
          $description = $('.product__description').children().not('.tabs,.tabs-content,h2');
          $('.tab-description .tab-content__inner').append($description);
          $('.product__description').remove();
      } else {
          $('.product__description .tabs, .product__description .tabs-content').remove();
          $('.product__description').removeClass('hidden');
      }
      
      // Add heights for tabs and collapse them
      $('.tab-content').each( function() {
          var height = $(this).outerHeight();
          $(this).data('height', height);
          $(this).css('height', 0);
      });
      
      // Show and hide tabs content on click. 
      $('.description-tabs .tab h3').click( function() {
      
          var $currentTab = $(this).parent();
          
          if ($currentTab.hasClass('active')) {
              $currentTab.toggleClass('active').find('.tab-content').css('height', 0);
          } else {
              var height = $currentTab.find('.tab-content').data('height');
              $currentTab.toggleClass('active').find('.tab-content').css('height', height + 'px');
          }
      
      });
  
    }

    function myHaltiProductSearch() {

      $('#myhalti-search').submit(function(e) {
      
        // Prevent the default form submission
        e.preventDefault(); 
        
        // Get the product code from the form and sanitize it
        var productCode = sanitizeInput($('form #product-code').val()); 
        
        // Fetch the data from the server
        fetch('https://myhalti.konsepto-asiakas.fi', {
        
          // Define the request method, headers and body
          method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            productCode: `${productCode}`
          })
        })
          
          // Parse the response
          .then(response => response.json())
            
          // Add the data to the page
          .then(results => {

            // If matching row is found
            if ( results.status === 'Success') {
  
              // Make sure that product details container is empty
              $('#product-details').empty(); 
  
              // Add the start of an unordered list
              $('#product-details').append('<ul>');            
  
              // Add each product feature as list item
              Object.entries(results.data).forEach(([key, value]) => {
                  $('#product-details ul').append(`<li><strong>${key}</strong> ${value}`);
              });
  
              // Add the end of an unordered list
              $('#product-details').append('</ul>');   
              
            } else {

              // Make sure that product details container is empty
              $('#product-details').empty(); 

              // Append an error message
              $('#product-details').append(results.message);   
              
            }

          })
            
          // Log any errors
          .catch((error) => {
            
            console.error('Error:', error);
          
          });

      });
      
    }

    function sanitizeInput(input) {

      // Basic sanitization: remove script tags and potentially harmful characters
      const sanitized = input
        
        .replace(/<script.*?>.*?<\/script>/gi, '')  // Remove script tags
        .replace(/<[^\>]*>/g, '')                  // Remove any remaining HTML tags
        .replace(/&/g, '&amp;')                    // Escape ampersand
        .replace(/</g, '&lt;')                     // Escape less than
        .replace(/>/g, '&gt;')                     // Escape greater than
        .replace(/"/g, '&quot;')                   // Escape double quote
        .replace(/'/g, '&#39;');                   // Escape single quote

      return sanitized;

    }

}(jQuery);